import { render } from "./ExpandedPassings.vue?vue&type=template&id=31d8ee2b&scoped=true"
import script from "./ExpandedPassings.vue?vue&type=script&lang=js"
export * from "./ExpandedPassings.vue?vue&type=script&lang=js"

import "./ExpandedPassings.vue?vue&type=style&index=0&id=31d8ee2b&scoped=true&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31d8ee2b"]])

export default __exports__